import(/* webpackMode: "eager", webpackExports: ["HistoricalTable"] */ "/app/src/components/prices/HistoricalTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MonthlyHeatmap"] */ "/app/src/components/prices/MonthlyHeatmap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PriceHistoryChart"] */ "/app/src/components/prices/PriceHistoryChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YearlyPerformance"] */ "/app/src/components/prices/YearlyPerformance.tsx");
